import { RuleActionType } from '@jupiterone/jupiter-types';
import {
  IntegrationInstanceSelector,
  JSONInput,
} from '@jupiterone/jupiter-web-toolkit';
import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  ServiceNowActionData,
  RuleActionData,
} from 'jupiter-web-alerts/src/types';

const DEFAULT_DESCRIPTION =
  "{{alertWebLink}}\n\n**Affected Items:**\n\n* {{queries.query0.data|mapProperty('displayName')|join('\n* ')}}";

const HELP_TEXT =
  'Request body sent to /api/now/table/incident endpoint. You can discover additional fields by visiting the "REST API Explorer" page in your ServiceNow deployment. The request will automatically assign the `number` property to be `j1:{rule-instance-id}`.';

interface Props {
  onUpdate: (newValue: RuleActionData) => void;
  disabled?: boolean;
  initialActionData?: ServiceNowActionData;
}

const DEFAULT_ACTION_DATA: ServiceNowActionData = {
  type: RuleActionType.CREATE_SERVICE_NOW_INCIDENT,
  integrationInstanceId: '',
  requestBody: {
    description: DEFAULT_DESCRIPTION,
    category: null,
    priority: null,
    impact: null,
    severity: null,
  },
};

const ServiceNowRuleConfig = ({
  onUpdate,
  disabled,
  initialActionData = DEFAULT_ACTION_DATA,
}: Props) => {
  const [integrationInstanceId, setIntegrationInstanceId] = useState<string>(
    initialActionData.integrationInstanceId
  );
  const [requestBody, setRequestBody] = useState<
    ServiceNowActionData['requestBody']
  >(initialActionData.requestBody);

  useEffect(() => {
    const action: ServiceNowActionData = {
      type: RuleActionType.CREATE_SERVICE_NOW_INCIDENT,
      integrationInstanceId,
      requestBody,
    };
    onUpdate(action);
  }, [integrationInstanceId, requestBody]);

  const handleChangeIntegrationInstanceId = (integrationInstanceId: string) => {
    setIntegrationInstanceId(integrationInstanceId);
  };

  const handleChangeServiceNowRequestBody = (
    e: ChangeEvent<{ value: any }>
  ) => {
    setRequestBody(e.target.value as ServiceNowActionData['requestBody']);
  };

  return (
    <div>
      <IntegrationInstanceSelector
        disabled={disabled}
        value={integrationInstanceId}
        integrationFilter="servicenow"
        onSelect={handleChangeIntegrationInstanceId}
      />
      <JSONInput
        value={requestBody}
        onChange={handleChangeServiceNowRequestBody}
        label={'Request Body'}
        disabled={disabled}
        name={'requestBody'}
        helpText={HELP_TEXT}
      />
    </div>
  );
};

export default ServiceNowRuleConfig;
